import { Point } from "../../graphicLibs/index";
import { PointInfo } from "../../WalltoFittingInfo";
import { CreatePointData } from "../CreatePointData";
import * as THREE from 'three';

/** 
 * 軸平行でない独立壁の削除
 * */
export class DeleteDiagonalWall {

    private radMin: number = 0;
    private radMax: number = 0;
    private radMin_: number = 0;
    private radMax_: number = 0;

    constructor(public pointList: PointInfo[]) {

    }

    public execute(): PointInfo[] {

        const x = new THREE.Vector3(1, 0, 0);
        // const rad10 = 0.174533; // 10度の時のラジアン
        // const rad80 = 1.39626; // 80度の時のラジアン
        // const rad100 = 1.74533; // 100度の時のラジアン
        // const rad170 = 2.96706; // 170度の時のラジアン

        const pointData = new CreatePointData(this.pointList);
        pointData.execute();
        const branchList = pointData.branchList;

        branchList.forEach((index: number) => {
            const p1 = this.pointList[index].point;
            const p2 = this.pointList[Point.nextPoint(index)].point;
            const vec = p2.clone().sub(p1);

            // x軸と直角もしくは並行かどうか（10度より大きく80未満, 100度より大きく170度未満）
            if (this.radMin < x.clone().angleTo(vec) && x.clone().angleTo(vec) < this.radMax
            || this.radMin_ < x.clone().angleTo(vec) && x.clone().angleTo(vec) < this.radMax_) {
                this.pointList[index].isDelete = true;              
                this.pointList[Point.nextPoint(index)].isDelete = true;              
            }
        });

        return this.pointList;

    }

    public length(degree: number) {
        this.radMin = degree * ( Math.PI / 180 );
        this.radMax = (90 - degree) * ( Math.PI / 180 );
        this.radMin_ = (90 + degree) * ( Math.PI / 180 );
        this.radMax_ = (180 - degree) * ( Math.PI / 180 );
    }

}